import React from 'react';

import { SelectInput } from 'hosman-material';

const huntInterestOptions = [
  { id: 1, value: 'interested', name: 'Oui, je souhaite en savoir plus' },
  { id: 2, value: 'not_interested', name: 'Non merci' }
];

const HuntInterestSelect = ({ buyerAlert, setStateBuyerAlert, errors }) => {
  return (
    <div className='min-w-[280px]'>
      <SelectInput
        name='hunt_interest'
        options={huntInterestOptions}
        selectedOption={huntInterestOptions.find(option => option.value === buyerAlert.hunt_interest) || null}
        handleChange={(e) => setStateBuyerAlert({ ...buyerAlert, hunt_interest: e.value })}
        label={
          <>
            Besoin d'un accompagnement ?
            <br />
            Découvrez notre service de chasse immobilière : un chasseur dédié et un accès à des biens avant publication. Les conditions vous seront présentées lors d'un échange avec un conseiller.
          </>
        }
        errors={errors}
      />
    </div>
  )
}

export default HuntInterestSelect;
